import { Fields } from '@measured/puck';
import { JustifyOptions } from '../../utils/constants';

export type JustifyContentProps = {
  justifyContent: string;
};

export const JustifyContentField: Fields<JustifyContentProps> = {
  justifyContent: {
    type: 'select',
    label: 'Justify-Content',
    options: JustifyOptions,
  },
};
